import { ca } from '@cian/analytics';

export function trackShowSpecialPromos() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'show_promotions_builder',
    useLastProducts: true,
  });
}

export function trackClickSpecialPromos() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'click_promotions_builder',
    label: 'show_more_promotion',
    useLastProducts: true,
  });
}

export function trackClickSpecialPromosMobile() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'click_promotions_builder',
    useLastProducts: true,
  });
}
